import { render, staticRenderFns } from "./param-antecedents.html?vue&type=template&id=5f5bbd54&scoped=true&external"
import script from "./param-antecedents.js?vue&type=script&lang=js&external"
export * from "./param-antecedents.js?vue&type=script&lang=js&external"
import style0 from "./param-antecedents.scss?vue&type=style&index=0&id=5f5bbd54&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5bbd54",
  null
  
)

export default component.exports